import { LocationChangeListener } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { de, th } from 'date-fns/locale';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { CommonService } from '../../shared/common.service';
import { CircleService } from '../circles/circle.service';
import { HomeService } from '../home.service';

@Component({
  selector: 'app-view-user-profile',
  templateUrl: './view-user-profile.component.html',
  styleUrls: ['./view-user-profile.component.scss']
})
export class ViewUserProfileComponent implements OnInit {
  messageText =""
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  datalist: [1, 2, 3, 4, 5, 6, 7, 8, 9]
  userId: any;
  isLoading: boolean = false;
  userDetails: any
  circleId = "";
  fromType: string;
  discussionId:string;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  userAboutForm:FormGroup;
  MembershipForm:FormGroup;
  InstituteForm:FormGroup;
  profExpForm:FormGroup;
  researchExpForm:FormGroup;
  fundingForm:FormGroup;
  WorkgroupsForm :FormGroup;
  roleList: Array<object> = [];
  diseaseList: Array<object> = [];
  focusList: Array<object> = [{name:'Focus 1'},{name:'Focus 2'},{name:'Focus 3'}];
  ExpLevelList:Array<object> = [{name:'Early stage (0-3 years)'},{name:'Mid-level (3-7 years)'},{name:'Experienced (More than 7 years)'}];
  studyTypeList:Array<object> = [{name:'Interventional'},{name:'Observational'},{name:'Registry'}];
  studyPhaseList:Array<object> = [{name:'Early Phase 1'},{name:'Phase 1'},{name:'Phase 2'},{name:'Phase 3'},{name:'Phase 4'},{name:'Not Applicable'}];

  membershipList: Array<object> = [];
  education: Array<object> = [];
  professionalExp: Array<object> = [];
  researchExp: Array<object> = [];
  fundingHistory:Array<object> = [];
  socialLinkList = []
  publications = [];
  publicationText:string = '';
  commentText:string = '';
  dropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userRoleId',
    textField: 'roleName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll:false,
    closeDropDownOnSelection:false
  };
  dropdownSettings1:IDropdownSettings = {
    singleSelection: false,
    idField: 'diseaseId',
    textField: 'diseaseName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll:false,
    closeDropDownOnSelection:false,
  };
  dropdownSettings3:IDropdownSettings = {
    singleSelection: false,
    idField: 'name',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll:false,
    closeDropDownOnSelection:false
  };
  dropdownSettings4:IDropdownSettings = {
    singleSelection: false,
    idField: 'name',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll:false,
    closeDropDownOnSelection:false
  };
  dropdownSettings5:IDropdownSettings = {
    singleSelection: false,
    idField: 'name',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll:false,
    closeDropDownOnSelection:false
  };
  dropdownSettings6:IDropdownSettings = {
    singleSelection: false,
    idField: 'name',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll:false,
    closeDropDownOnSelection:false
  };
  dropdownSettingCountry: IDropdownSettings = {
    singleSelection: true,
    idField: 'code',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false
  };
  dropdownSettingCircle: IDropdownSettings = {
    singleSelection: false,
    idField: 'circleId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false
  };
  isTabOpn:boolean = false;
  contactInfoShow: boolean = false;
  educationShow: boolean = false;
  fundingHistoryShow: boolean = false;
  membershipShow: boolean = false;
  nbstrnShow: boolean = false;
  professionalExpShow: boolean = false;
  publicationsShow: boolean = false;
  researchExpShow: boolean = false;
  countryList =[
    {"name": "Albania", "code": "AL"},
    {"name": "Åland Islands", "code": "AX"},
    {"name": "Algeria", "code": "DZ"},
    {"name": "American Samoa", "code": "AS"},
    {"name": "Andorra", "code": "AD"},
    {"name": "Angola", "code": "AO"},
    {"name": "Anguilla", "code": "AI"},
    {"name": "Antarctica", "code": "AQ"},
    {"name": "Antigua and Barbuda", "code": "AG"},
    {"name": "Argentina", "code": "AR"},
    {"name": "Armenia", "code": "AM"},
    {"name": "Aruba", "code": "AW"},
    {"name": "Australia", "code": "AU"},
    {"name": "Austria", "code": "AT"},
    {"name": "Azerbaijan", "code": "AZ"},
    {"name": "Bahamas (the)", "code": "BS"},
    {"name": "Bahrain", "code": "BH"},
    {"name": "Bangladesh", "code": "BD"},
    {"name": "Barbados", "code": "BB"},
    {"name": "Belarus", "code": "BY"},
    {"name": "Belgium", "code": "BE"},
    {"name": "Belize", "code": "BZ"},
    {"name": "Benin", "code": "BJ"},
    {"name": "Bermuda", "code": "BM"},
    {"name": "Bhutan", "code": "BT"},
    {"name": "Bolivia (Plurinational State of)", "code": "BO"},
    {"name": "Bonaire, Sint Eustatius and Saba", "code": "BQ"},
    {"name": "Bosnia and Herzegovina", "code": "BA"},
    {"name": "Botswana", "code": "BW"},
    {"name": "Bouvet Island", "code": "BV"},
    {"name": "Brazil", "code": "BR"},
    {"name": "British Indian Ocean Territory (the)", "code": "IO"},
    {"name": "Brunei Darussalam", "code": "BN"},
    {"name": "Bulgaria", "code": "BG"},
    {"name": "Burkina Faso", "code": "BF"},
    {"name": "Burundi", "code": "BI"},
    {"name": "Cabo Verde", "code": "CV"},
    {"name": "Cambodia", "code": "KH"},
    {"name": "Cameroon", "code": "CM"},
    {"name": "Canada", "code": "CA"},
    {"name": "Cayman Islands (the)", "code": "KY"},
    {"name": "Central African Republic (the)", "code": "CF"},
    {"name": "Chad", "code": "TD"},
    {"name": "Chile", "code": "CL"},
    {"name": "China", "code": "CN"},
    {"name": "Christmas Island", "code": "CX"},
    {"name": "Cocos (Keeling) Islands (the)", "code": "CC"},
    {"name": "Colombia", "code": "CO"},
    {"name": "Comoros (the)", "code": "KM"},
    {"name": "Congo (the Democratic Republic of the)", "code": "CD"},
    {"name": "Congo (the)", "code": "CG"},
    {"name": "Cook Islands (the)", "code": "CK"},
    {"name": "Costa Rica", "code": "CR"},
    {"name": "Croatia", "code": "HR"},
    {"name": "Cuba", "code": "CU"},
    {"name": "Curaçao", "code": "CW"},
    {"name": "Cyprus", "code": "CY"},
    {"name": "Czechia", "code": "CZ"},
    {"name": "Côte d'Ivoire", "code": "CI"},
    {"name": "Denmark", "code": "DK"},
    {"name": "Djibouti", "code": "DJ"},
    {"name": "Dominica", "code": "DM"},
    {"name": "Dominican Republic (the)", "code": "DO"},
    {"name": "Ecuador", "code": "EC"},
    {"name": "Egypt", "code": "EG"},
    {"name": "El Salvador", "code": "SV"},
    {"name": "Equatorial Guinea", "code": "GQ"},
    {"name": "Eritrea", "code": "ER"},
    {"name": "Estonia", "code": "EE"},
    {"name": "Eswatini", "code": "SZ"},
    {"name": "Ethiopia", "code": "ET"},
    {"name": "Falkland Islands (the) [Malvinas]", "code": "FK"},
    {"name": "Faroe Islands (the)", "code": "FO"},
    {"name": "Fiji", "code": "FJ"},
    {"name": "Finland", "code": "FI"},
    {"name": "France", "code": "FR"},
    {"name": "French Guiana", "code": "GF"},
    {"name": "French Polynesia", "code": "PF"},
    {"name": "French Southern Territories (the)", "code": "TF"},
    {"name": "Gabon", "code": "GA"},
    {"name": "Gambia (the)", "code": "GM"},
    {"name": "Georgia", "code": "GE"},
    {"name": "Germany", "code": "DE"},
    {"name": "Ghana", "code": "GH"},
    {"name": "Gibraltar", "code": "GI"},
    {"name": "Greece", "code": "GR"},
    {"name": "Greenland", "code": "GL"},
    {"name": "Grenada", "code": "GD"},
    {"name": "Guadeloupe", "code": "GP"},
    {"name": "Guam", "code": "GU"},
    {"name": "Guatemala", "code": "GT"},
    {"name": "Guernsey", "code": "GG"},
    {"name": "Guinea", "code": "GN"},
    {"name": "Guinea-Bissau", "code": "GW"},
    {"name": "Guyana", "code": "GY"},
    {"name": "Haiti", "code": "HT"},
    {"name": "Heard Island and McDonald Islands", "code": "HM"},
    {"name": "Holy See (the)", "code": "VA"},
    {"name": "Honduras", "code": "HN"},
    {"name": "Hong Kong", "code": "HK"},
    {"name": "Hungary", "code": "HU"},
    {"name": "Iceland", "code": "IS"},
    {"name": "India", "code": "IN"},
    {"name": "Indonesia", "code": "ID"},
    {"name": "Iran (Islamic Republic of)", "code": "IR"},
    {"name": "Iraq", "code": "IQ"},
    {"name": "Ireland", "code": "IE"},
    {"name": "Isle of Man", "code": "IM"},
    {"name": "Israel", "code": "IL"},
    {"name": "Italy", "code": "IT"},
    {"name": "Jamaica", "code": "JM"},
    {"name": "Japan", "code": "JP"},
    {"name": "Jersey", "code": "JE"},
    {"name": "Jordan", "code": "JO"},
    {"name": "Kazakhstan", "code": "KZ"},
    {"name": "Kenya", "code": "KE"},
    {"name": "Kiribati", "code": "KI"},
    {"name": "Korea (the Democratic People's Republic of)", "code": "KP"},
    {"name": "Korea (the Republic of)", "code": "KR"},
    {"name": "Kuwait", "code": "KW"},
    {"name": "Kyrgyzstan", "code": "KG"},
    {"name": "Lao People's Democratic Republic (the)", "code": "LA"},
    {"name": "Latvia", "code": "LV"},
    {"name": "Lebanon", "code": "LB"},
    {"name": "Lesotho", "code": "LS"},
    {"name": "Liberia", "code": "LR"},
    {"name": "Libya", "code": "LY"},
    {"name": "Liechtenstein", "code": "LI"},
    {"name": "Lithuania", "code": "LT"},
    {"name": "Luxembourg", "code": "LU"},
    {"name": "Macao", "code": "MO"},
    {"name": "Madagascar", "code": "MG"},
    {"name": "Malawi", "code": "MW"},
    {"name": "Malaysia", "code": "MY"},
    {"name": "Maldives", "code": "MV"},
    {"name": "Mali", "code": "ML"},
    {"name": "Malta", "code": "MT"},
    {"name": "Marshall Islands (the)", "code": "MH"},
    {"name": "Martinique", "code": "MQ"},
    {"name": "Mauritania", "code": "MR"},
    {"name": "Mauritius", "code": "MU"},
    {"name": "Mayotte", "code": "YT"},
    {"name": "Mexico", "code": "MX"},
    {"name": "Micronesia (Federated States of)", "code": "FM"},
    {"name": "Moldova (the Republic of)", "code": "MD"},
    {"name": "Monaco", "code": "MC"},
    {"name": "Mongolia", "code": "MN"},
    {"name": "Montenegro", "code": "ME"},
    {"name": "Montserrat", "code": "MS"},
    {"name": "Morocco", "code": "MA"},
    {"name": "Mozambique", "code": "MZ"},
    {"name": "Myanmar", "code": "MM"},
    {"name": "Namibia", "code": "NA"},
    {"name": "Nauru", "code": "NR"},
    {"name": "Nepal", "code": "NP"},
    {"name": "Netherlands (the)", "code": "NL"},
    {"name": "New Caledonia", "code": "NC"},
    {"name": "New Zealand", "code": "NZ"},
    {"name": "Nicaragua", "code": "NI"},
    {"name": "Niger (the)", "code": "NE"},
    {"name": "Nigeria", "code": "NG"},
    {"name": "Niue", "code": "NU"},
    {"name": "Norfolk Island", "code": "NF"},
    {"name": "Northern Mariana Islands (the)", "code": "MP"},
    {"name": "Norway", "code": "NO"},
    {"name": "Oman", "code": "OM"},
    {"name": "Pakistan", "code": "PK"},
    {"name": "Palau", "code": "PW"},
    {"name": "Palestine, State of", "code": "PS"},
    {"name": "Panama", "code": "PA"},
    {"name": "Papua New Guinea", "code": "PG"},
    {"name": "Paraguay", "code": "PY"},
    {"name": "Peru", "code": "PE"},
    {"name": "Philippines (the)", "code": "PH"},
    {"name": "Pitcairn", "code": "PN"},
    {"name": "Poland", "code": "PL"},
    {"name": "Portugal", "code": "PT"},
    {"name": "Puerto Rico", "code": "PR"},
    {"name": "Qatar", "code": "QA"},
    {"name": "Republic of North Macedonia", "code": "MK"},
    {"name": "Romania", "code": "RO"},
    {"name": "Russian Federation (the)", "code": "RU"},
    {"name": "Rwanda", "code": "RW"},
    {"name": "Réunion", "code": "RE"},
    {"name": "Saint Barthélemy", "code": "BL"},
    {"name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH"},
    {"name": "Saint Kitts and Nevis", "code": "KN"},
    {"name": "Saint Lucia", "code": "LC"},
    {"name": "Saint Martin (French part)", "code": "MF"},
    {"name": "Saint Pierre and Miquelon", "code": "PM"},
    {"name": "Saint Vincent and the Grenadines", "code": "VC"},
    {"name": "Samoa", "code": "WS"},
    {"name": "San Marino", "code": "SM"},
    {"name": "Sao Tome and Principe", "code": "ST"},
    {"name": "Saudi Arabia", "code": "SA"},
    {"name": "Senegal", "code": "SN"},
    {"name": "Serbia", "code": "RS"},
    {"name": "Seychelles", "code": "SC"},
    {"name": "Sierra Leone", "code": "SL"},
    {"name": "Singapore", "code": "SG"},
    {"name": "Sint Maarten (Dutch part)", "code": "SX"},
    {"name": "Slovakia", "code": "SK"},
    {"name": "Slovenia", "code": "SI"},
    {"name": "Solomon Islands", "code": "SB"},
    {"name": "Somalia", "code": "SO"},
    {"name": "South Africa", "code": "ZA"},
    {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
    {"name": "South Sudan", "code": "SS"},
    {"name": "Spain", "code": "ES"},
    {"name": "Sri Lanka", "code": "LK"},
    {"name": "Sudan (the)", "code": "SD"},
    {"name": "Suriname", "code": "SR"},
    {"name": "Svalbard and Jan Mayen", "code": "SJ"},
    {"name": "Sweden", "code": "SE"},
    {"name": "Switzerland", "code": "CH"},
    {"name": "Syrian Arab Republic", "code": "SY"},
    {"name": "Taiwan (Province of China)", "code": "TW"},
    {"name": "Tajikistan", "code": "TJ"},
    {"name": "Tanzania, United Republic of", "code": "TZ"},
    {"name": "Thailand", "code": "TH"},
    {"name": "Timor-Leste", "code": "TL"},
    {"name": "Togo", "code": "TG"},
    {"name": "Tokelau", "code": "TK"},
    {"name": "Tonga", "code": "TO"},
    {"name": "Trinidad and Tobago", "code": "TT"},
    {"name": "Tunisia", "code": "TN"},
    {"name": "Turkey", "code": "TR"},
    {"name": "Turkmenistan", "code": "TM"},
    {"name": "Turks and Caicos Islands (the)", "code": "TC"},
    {"name": "Tuvalu", "code": "TV"},
    {"name": "Uganda", "code": "UG"},
    {"name": "Ukraine", "code": "UA"},
    {"name": "United Arab Emirates", "code": "AE"},
    {"name": "United Kingdom of Great Britain and Northern Ireland (the)", "code": "GB"},
    {"name": "United States Minor Outlying Islands", "code": "UM"},
    {"name": "United States of America", "code": "US"},
    {"name": "Uruguay", "code": "UY"},
    {"name": "Uzbekistan", "code": "UZ"},
    {"name": "Vanuatu", "code": "VU"},
    {"name": "Venezuela (Bolivarian Republic of)", "code": "VE"},
    {"name": "Viet Nam", "code": "VN"},
    {"name": "Virgin Islands (British)", "code": "VG"},
    {"name": "Virgin Islands (U.S.)", "code": "VI"},
    {"name": "Wallis and Futuna", "code": "WF"},
    {"name": "Western Sahara", "code": "EH"},
    {"name": "Yemen", "code": "YE"},
    {"name": "Zambia", "code": "ZM"},
    {"name": "Zimbabwe", "code": "ZW"}
  ]
  step1 = true;
  step2 = true;
  step3 = true;
  step4 = true;
  step5 = true;
  step6 = true;
  step7 = true;
  step8 = true;;
  projectDetailSign:any;
  circleList = []
  constructor(
    private route: ActivatedRoute,
    private CircleService: CircleService,
    private HomeService: HomeService,
    private router: Router,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private commonService:CommonService,
    private modalService: NgbModal

    ) { }
    getUserTokenDetail:any;
  ngOnInit() {
    window.scrollTo(0, 0);
    this.projectDetailSign = JSON.parse(localStorage.getItem("project_Signup")) || "noemail";
   
   let userToken = this.commonService.getUser();
    this.getUserTokenDetail = userToken.userId
    this.initialiseForms();
    this.getUserRole();
    this.getDiesease();
    this.getFocus();
    this.getPubclicCircle();

    this.route.queryParams.subscribe(param => {
      this.userId = param['id'];
      this.circleId = param['circle'];
      this.fromType = param['from'];
      this.isTabOpn = param['isTabOpn'];
      this.discussionId = param['discussionId'];
      if (this.userId ) {
        this.getUserProfile()
        this.getCircleActivity()
      }
 
    });
    
  }
  circleActivity:any
  getCircleActivity() {
    this.isLoading = true;
    // let query = ""
   let query = "userId="+ this.userId
    this.CircleService.getUserProfileCircleActivity(query).subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.circleActivity = res.data.activityList;
        
      } else {
        this.circleActivity
         = []
      }
    }, err => {
      this.isLoading = false;
    });
  }
  getPubclicCircle() {
    let query = "limit=1000";
    this.HomeService.getPublicCircle(query).subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.circleList = res.data.circleList;
        // this.PatchCircle(this.circleDetails)
      } else {
        this.roleList
          = []
      }
    }, err => {
      this.isLoading = false;
    });
  }
  getUserRole() {
    this.isLoading = true;
    this.HomeService.getUserRole("").subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.roleList = res.data.userRolesList;
        
      } else {
        this.roleList
         = []
      }
    }, err => {
      this.isLoading = false;
    });
  }
  getFocus() {
    this.isLoading = true;
    this.HomeService.getReaarchInfo().subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.focusList = res.data.researchFocusList;
        
      } else {
        this.diseaseList= []
      }
    }, err => {
      this.isLoading = false;
    });
  }
  getDiesease() {
    this.isLoading = true;
    this.HomeService.getUserDiseases("").subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.diseaseList = res.data.diseasesList;
        
      } else {
        this.diseaseList= []
      }
    }, err => {
      this.isLoading = false;
    });
  }

  tempresearchFocus = []
  tempdisease= []
  tempRols = []
  patchUserForm(data){
    this.userAboutForm.patchValue({
      fullName: data['fullName'],
      email: data['email'],
      profilePic: data['profilePic'],
      institution: data['institution'],
      jobTitle: data['jobTitle'],
      mobile: data['mobile'],
      address:data['address'],
      other: data['other'],
      department:data['department'],
      introduction:data['introduction'],
      socialMediaLink:data['socialMediaLink']
    });
    this.socialLinkList =data['socialMediaLink'];
    this.WorkgroupsForm.patchValue({
      userAvailable: data['nbstrn']['userAvailable'],
      comments: data['nbstrn']['comments']
    });
    

    
    
    if(data['roleIds'].length > 0) {
        var i;
      for (i = 0; i < data['roleIds'].length; i++) {
        this.tempRols.push({userRoleId:data['roleIds'][i],roleName:data['userRoles'][i]})
      }
      this.userAboutForm.controls.roleIds.setValue(this.tempRols);
    } 
    this.onItemSelectRole("");
    let tempCountry =[];
    if(data['country']){
      this.countryList.forEach(element => {
        if(element['name'] == data['country']){
          tempCountry.push(element);
        }
        
      });
      
      this.userAboutForm.controls.country.setValue(tempCountry);
    }
   
    this.onItemDeSelectCircle("")
    let tempdisease = []
    if(data['diseaseOfInterestIds'] && data['diseaseOfInterestIds'].length > 0) {
      var j;
      for (j = 0; j < data['diseaseOfInterestIds'].length; j++) {
        this.tempdisease.push({diseaseId:data['diseaseOfInterestIds'][j],diseaseName:data['diseaseOfInterestNames'][j]})
      }
      this.userAboutForm.controls.diseaseOfInterestIds.setValue(tempdisease);
    } 
    if(data['membership'].length > 0) {
      this.membershipList = data['membership']
    }
    if(data['professionalExp'].length > 0) {
      this.professionalExp = data['professionalExp']
    }
    if(data['publications'].length > 0) {
      this.publications = data['publications']
    }
    if(data['education'].length > 0) {
      this.education = data['education']
    }
    if(data['fundingHistory'].length > 0) {
      this.fundingHistory = data['fundingHistory']
    }

      this.userAboutForm.disable();
      this.WorkgroupsForm.disable();
  }
  onItemSelectCountry(event){

  }
  onSelectAllCountry(event){
    
  }
  onItemDeSelectCountry(event){
    
  }
  onItemSelectCircle(event){

  }
  onSelectAllCircle(event){
    
  }
  onItemDeSelectCircle(event){
    
  }
  onItemSelectRole(event){
    for (let i = 0; i < this.userAboutForm.value.roleIds.length; i++) {
      for (let j = 0; j < this.roleList.length; j++) {
        if(this.userAboutForm.value.roleIds[i]['userRoleId'] == this.roleList[j]['userRoleId']) {
          
          if(this.roleList[j]['roleName'] == 'Researcher' || this.roleList[j]['roleName'] == 'Clinician' || this.roleList[j]['roleName'] == 'Advocacy Groups') {
            this.contactInfoShow= true;
            this.educationShow =true;
            this.fundingHistoryShow =  true;
            this.membershipShow= true;
            this.nbstrnShow = true;
            this.professionalExpShow= true;
            this.publicationsShow= true;
            this.researchExpShow =true;
          } 
          if(this.roleList[j]['roleName'] == 'Families and Caregivers'|| this.roleList[j]['roleName'] == 'Parents' || this.roleList[j]['roleName'] == 'Federal Groups' || this.roleList[j]['roleName'] == 'Others' || this.roleList[j]['roleName'] == 'State/Public Health Programs') {
            this.contactInfoShow= true;
            this.nbstrnShow = true;
            this.publicationsShow= true;
            this.researchExpShow =false;
            this.educationShow =false;
            this.fundingHistoryShow =  false;
            this.membershipShow= true;
            this.professionalExpShow= false;

          } 
        }
      }
    }
    //If researcher, clinician or advocacy group is selected then all sections will appear otherwise 
    
  }
  checkRole(userblock){
    if(userblock['contactInfo'] == 'M' || userblock['contactInfo'] == 'O'){
      this.contactInfoShow = true;
    }
    if(userblock['contactInfo'] == 'H'){
      this.contactInfoShow = false;
    }
    if(userblock['membership'] == 'M' || userblock['membership'] == 'O'){
      this.membershipShow = true;
    }
    if(userblock['membership'] == 'H'){
      this.membershipShow = false;
    }
    if(userblock['nbstrn'] == 'M' || userblock['nbstrn'] == 'O'){
      this.nbstrnShow = true;
    }
    if(userblock['nbstrn'] == 'H'){
      this.nbstrnShow = false;
    }
  
    if(userblock['publications'] == 'M' || userblock['publications'] == 'O'){
      this.publicationsShow = true;
    }
    if(userblock['publications'] == 'H'){
      this.publicationsShow = false;
    }
    if(userblock['fundingHistory'] == 'M' || userblock['fundingHistory'] == 'O'){
      this.fundingHistoryShow = true;
    }
    if(userblock['fundingHistory'] == 'H'){
      this.fundingHistoryShow = false;
    }

  }
  tempexpLevel = []
  patchresearchForm(data) {
    if(data['researchExp'] && data['researchExp'].lenght > 0) {

      this.researchExpForm.patchValue({
        studiesCompleted: data['researchExp']['studiesCompleted'],
        studiesOngoing: data['researchExp']['studiesOngoing'],
      });
  
     
      if(data['researchExp']){
        this.tempexpLevel.push({name:data['researchExp']['expLevel']})
        this.researchExpForm.controls.expLevel.setValue(this.tempexpLevel);
      }
      let tempstudyTypes = []
      
      if(data['researchExp']['studyTypes'] && data['researchExp']['studyTypes'].length > 0) {
        var i;
        for (i = 0; i <data['researchExp']['studyTypes'].length; i++) {
          tempstudyTypes.push({name:data['researchExp']['studyTypes'][i]})
          }
          this.researchExpForm.controls.studyTypes.setValue(tempstudyTypes);
        } 
  
        let tempstudyPhase = []
      if( data['researchExp']['studyPhases'] &&  data['researchExp']['studyPhases'].length > 0) {
        var j;
        for (j = 0; j < data['researchExp']['studyPhases'].length; j++) {
          tempstudyPhase.push({name:data['researchExp']['studyPhases'][j]})
          }
          this.researchExpForm.controls.studyPhases.setValue(tempstudyPhase);
        } 
    }



    }

    onlyNumberKey(event) {
      return event.charCode == 8 || event.charCode == 0
        ? null
        : event.charCode >= 48 && event.charCode <= 57;
    }
  

  onItemSelectProduct(item: any) {
  }
  onItemDeSelect(item:any) {
  }
  onSelectAllProduct(items: any) {
  }

  openwebView(value) {

    let index =value.indexOf('http');
    let url  = '';
    if (index == -1) {
         url = 'http://' + value ;
    }
    else 
    {
        url = value ;
    }
    window.open(url, "_blank");
  }
  setStep(index: number) {
    if(index == 1) {
      this.step1=!this.step1;
    }
  }
  initialiseForms() {
    this.userAboutForm = this.fb.group({
      fullName: ["", [Validators.required]], //done
      email: ["", [Validators.required,Validators.pattern(this.emailPattern)]], //done
      profilePic: [""],
      department:[""],
      institution: ["", [Validators.required]],
      roleIds: ["", [Validators.required]], //done
      jobTitle: [""],//done
      mobile: [""], //done
      address: [""],//done
      researchFocus: [""],//done
      other: [""],
      diseaseOfInterestIds: [""],//done
      introduction: [""],
      socialMediaLink: [""],
      country: [[]],
      circlesOfInterest: [[]],
    });
    this.MembershipForm = this.fb.group({
      institution: ["", [Validators.required]],
      department: [""],
      jobTitle: ["", [Validators.required]],
      comment: ["", [Validators.required]],
      membershipYear: [""],
    });
    this.InstituteForm = this.fb.group({
      institution: ["", [Validators.required]],
      degree: ["",[Validators.required]],
      year: ["", [Validators.required]],
      fieldOfStudy: ["",[Validators.required]],
    });
    this.profExpForm = this.fb.group({
      institution: ["", [Validators.required]],
      jobTitle: ["",[Validators.required]],
      yearStarted: ["", [Validators.required]],
      yearCompleted: ["",[Validators.required]],
    });
    this.fundingForm = this.fb.group({
      grantNo: ["", [Validators.required]],
      contractNo: ["",[Validators.required]],
      grantTitle: ["", [Validators.required]],
      agency: ["",[Validators.required]],
    });
    this.researchExpForm = this.fb.group({
      expLevel: ["", [Validators.required]],
      studyTypes: ["",[Validators.required]],
      studyPhases: ["", [Validators.required]],
      studiesCompleted: ["",[Validators.required]],
      studiesOngoing: ["",[Validators.required]],
    });
    this.WorkgroupsForm = this.fb.group({
      userAvailable: [false],
      comments: [""],
     
    });


  }

 
  getUserProfile() {
    this.isLoading = true;
    this.CircleService.getUserProfileApi(this.userId).subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this.userDetails = res.data.userList[0];
        this.patchUserForm(this.userDetails);
        this.patchresearchForm(this.userDetails);
      
      } else {
        this.userDetails = []
      }
    }, err => {
      this.isLoading = false;
    });
  }

  navigateBack() {
    //if status come then i will come from dashboard
    //1 from member search
    //2 from  view connection
    //3 from  send connection
    //4 from  recivvev connection
    if (this.fromType == '1') {
      this.router.navigate(["main/circles/search-user"]);
      return
    }
    
    if (this.fromType == '2') {
      this.router.navigate(["main/connection/your"]);
      return
    }
    if (this.fromType == 'edit') {
      this.router.navigate(["main/user-profile-edit"],{ queryParams: { userId: this.userId,from:'admin' }});
      return
    }

    if (this.fromType == '3') {
      this.router.navigate(["main/connection/sent-req"]);
      return
    }
    if (this.fromType == '4') { 
      this.router.navigate(["main/connection/received-req"]);
      return
    }
    if (this.fromType == '5') { 
      this.router.navigate(["main/circles/search-all"]);
      return
    }
    if (this.fromType == '6') {
      this.router.navigate(["main/circles/search-all/all-members-search"]);
      return
    }
    if (this.fromType == '7') { 
      this.router.navigate(["/main/circles/circle-full-profile"], { queryParams: { id:this.circleId,from:3,type:'public' } });
      return
    }
    if (this.fromType == 'discussion') { 
      this.router.navigate(["/main/dashboard/discussion/"+this.discussionId],{ queryParams: { isTabOpn:this.isTabOpn} });
      return
    }
    if (this.circleId) {
      this.router.navigate(["/main/circles/circle-profile/circle-members"], { queryParams: { id: this.circleId } });
    } else {
      this.router.navigate(["main/dashboard/event/discussion-board"]);
    }

  }

  denyRequest1(data) {
    Swal.fire({
      title: "Are you sure, you want to reject your request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm"
    }).then(result => {
      if (result.isConfirmed == true) {
        this.isLoading = true;
        let req = {
          connectionRequestId:data,
          statusReceiver : 'rejected'
        }
        this.CircleService.UpdateConnetion(req).subscribe(
          res => {
            this.isLoading = false; 
            if (res["message"] == "Success") {
  
              this.getUserProfile();
              this._snackBar.open("Request cancelled successfully !", "", {
                duration: 5000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"]
              });
              //this.modalRef.close();
              //this.getchildReport();
              
            } else {
            }
          },
          err => {
            this.isLoading = false;
          }
        );
      }
    });
  }
  id:any

  requestModal1(content,row,btn) {
  this.modelOptions = {
    backdrop: "static",
    keyboard: false,
    centered:true,
    size:'md',
  };
  
this.id= row.connectionId;
  btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
  this.modalRef = this.modalService.open(content, this.modelOptions);
  this.modalRef.result.then(
    result => {
      this.closeResult = `Closed with: ${result}`;
    },
    reason => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    }
  );
}


AcceptDeny1 () {

  this.isLoading = true;
  let req = {
    connectionId:this.id,
    statusSender:'canceled'
  }
  this.CircleService.removeConnetion(this.id).subscribe(
    res => {
      this.isLoading = false; 
      if (res["message"] == "Success") {

        this.getUserProfile();
        this.modalRef.close();
        
    
          this._snackBar.open("Connection removed successfully !", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"]
          });
    
        
        //this.modalRef.close();
        //this.getchildReport();
        
      } else {
      }
    },
    err => {
      this.isLoading = false;
    }
  );
}
  sendRequest(text) {

    let request = {
      "receiverId": this.id1
    }
    if(text == 'send' && this.messageText.length == 0) {
      return this._snackBar.open("Please add message", "", {
         duration: 3000,
         horizontalPosition: "right",
         verticalPosition: "top",
         panelClass: ["success"]
       });
     }
     if(text == 'send' && this.messageText.length > 0) {
       request['message'] = this.messageText
     }
     this.isLoading = true;
    this.CircleService.createConnetion(request).subscribe((res) => {
      this.isLoading = false;
      if (res['message'] == 'Success') {
        this._snackBar.open("Request sent successfully !", "", {
          duration: 5000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"]
        });
        this.getUserProfile();
        this.modalRef.close()
        // this.router.navigate(["main/dashboard/event/discussion-board"]);
      }
    }, err => {
      this.isLoading = false;
      this.modalRef.close()
    });
  }
  denyRequest(data) {
    Swal.fire({
      title: "Are you sure, you want to cancel your request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm"
    }).then(result => {
      if (result.isConfirmed == true) {
        this.isLoading = true;
        let req = {
          connectionRequestId:data,
          statusSender:'canceled'
        }
        this.HomeService.UpdateConnetion(req).subscribe(
          res => {
            this.isLoading = false; 
            if (res["message"] == "Success") {
  
              this.getUserProfile();
              this._snackBar.open("Request canceled successfully !", "", {
                duration: 5000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"]
              });
              //this.modalRef.close();
              //this.getchildReport();
              
            } else {
            }
          },
          err => {
            this.isLoading = false;
          }
        );
      }
    });
  }
  removeRequest(data) {
    Swal.fire({
      title: "Are you sure, you want to remove connection?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm"
    }).then(result => {
      if (result.isConfirmed == true) {
        this.isLoading = true;
        
        this.HomeService.removeConnetion(data).subscribe(
          res => {
            this.isLoading = false; 
            if (res["message"] == "Success") {
              this.getUserProfile();
              this._snackBar.open("Connection removed successfully !", "", {
                duration: 5000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"]
              });
              //this.modalRef.close();
              //this.getchildReport();
              
            } else {
            }
          },
          err => {
            this.isLoading = false;
          }
        );
      }
    });
  }
  CancelRequest(Id){
    this.isLoading = true;
    let request ={
      "connectionRequestId":Id,
      statusSender:'canceled'
    }
   this.HomeService.UpdateConnetion(request).subscribe((res) => {
      this.isLoading = false;
       if(res['message'] =='Success') {
        this.getUserProfile();
       } 
     }, err => {
       this.isLoading = false;
     });
  }
  AcceptDeny2 () {
    this.isLoading = true;
    let request ={
      "connectionRequestId":this.id1,
      statusReceiver:'accepted'
    }
   this.CircleService.UpdateConnetion(request).subscribe((res) => {
        this.isLoading = false; 
        if (res["message"] == "Success") {
          this._snackBar.open("Request accepted successfully !", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"]
          });
          this.getUserProfile();
          this.modalRef.close();
         
         
            // this._snackBar.open("Request accepted successfully !", "", {
            //   duration: 5000,
            //   horizontalPosition: "right",
            //   verticalPosition: "top",
            //   panelClass: ["success"]
            // });
  
          
          //this.modalRef.close();
          //this.getchildReport();
          
        } else {
        }
      },
      err => {
        this.isLoading = false;
      }
    );
  }
  id1:any

  requestModal(content,row,btn) {
    this.messageText = "";
  this.modelOptions = {
    backdrop: "static",
    keyboard: false,
    centered:true,
    size:'md',
  };
  
this.id1= row;
  btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
  this.modalRef = this.modalService.open(content, this.modelOptions);
  this.modalRef.result.then(
    result => {
      this.closeResult = `Closed with: ${result}`;
    },
    reason => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    }
  );
}


AcceptDeny () {

  this.isLoading = true;
  let req = {
    connectionRequestId:this.id1,
    statusSender:'canceled'
  }
  this.HomeService.UpdateConnetion(req).subscribe(
    res => {
      this.isLoading = false; 
      if (res["message"] == "Success") {

       this.getUserProfile();
        this.modalRef.close();
        
    
          this._snackBar.open("Request cancelled successfully !", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"]
          });
    
        
        //this.modalRef.close();
        //this.getchildReport();
        
      } else {
      }
    },
    err => {
      this.isLoading = false;
    }
  );
}

closeModal(){
  this.modalRef.close();
}

  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  checkProperties(obj) {
    for (var key in obj) {
        if (obj[key] !== null && obj[key] != "")
            return false;
    }
    return true;
}


}
